<template>
  <div class="actions-container">
    <div class="logo-container pr-8">
      <button
          class="action-logo"
          :disabled="cameraOrMicBlocked"
          @click="$store.dispatch('localVideo', !localParticipant.video)"
      >
        <img
            :src="require('../../assets/img/action-1.svg')"
            style="width: 20px; height: 20px"
        />
      </button>
      <div class="action-name">Start</div>
    </div>
    <div class="logo-container pl-8 pr-8">
      <div
          class="action-logo"
          :disabled="cameraOrMicBlocked"
          @click="$store.dispatch('localAudio', !localParticipant.audio)"
      >
        <img
            :src="
            require('../../assets/img/action-' +
              (localParticipant.audio ? '2' : 'unmute') +
              '.svg')
          "
            style="width: 20px; height: 20px"
        />
      </div>
      <div class="action-name">
        {{ localParticipant.audio ? "Mute" : "Unmute" }}
      </div>
    </div>
    <div class="logo-container pl-8 pr-8">
      <div
          class="action-logo"
          @click="
          $store.dispatch(
            localParticipant.screen ? 'stopScreenShare' : 'startScreenShare'
          )
        "
      >
        <img
            :src="require('../../assets/img/action-3.svg')"
            style="width: 20px; height: 20px"
        />
      </div>
      <div class="action-name">Share</div>
    </div>
    <div @click="onRecordClick" class="logo-container pl-8 pr-8">
      <div :class="{
        'action-logo': true,
        'noactive': !isRecording,
        'active': isRecording
      }">
        <img
            :src="require('../../assets/img/action-4.svg')"
            style="width: 20px; height: 20px"
        />
      </div>
      <div class="action-name">Record</div>
    </div>
    <div @click="onBlurClick" class="logo-container pl-8 pr-8" v-if="localParticipant.video">
      <div :class="{
        'action-logo': true,
        'noactive': !blurredBackground,
        'active': blurredBackground
      }">
        <img
            :src="require('../../assets/img/action-blur.svg')"
            style="width: 20px; height: 20px"
        />
      </div>
      <div class="action-name">Blur</div>
    </div>

    <div class="logo-container pl-8 pr-8">
      <div class="action-logo" @click="showChatModal()">
        <img
            :src="require('../../assets/img/action-6.svg')"
            style="width: 20px; height: 20px"
        />
      </div>
      <div class="action-name">Chat</div>
    </div>
    <div class="logo-container pl-8 pr-8">
      <div class="action-logo" @click="showPeopleModal()">
        <img
            :src="require('../../assets/img/action-7.svg')"
            style="width: 20px; height: 20px"
        />
      </div>
      <div class="action-name">People</div>
    </div>
    <div class="logo-container pl-8 pr-8">
      <div class="action-logo" @click="toggleCaptions()">
        <img
            :src="require('../../assets/img/action-8.svg')"
            style="width: 20px; height: 20px"
        />
      </div>
      <div class="action-name">Caption</div>
    </div>
    <div class="logo-container pl-8">
      <div class="action-logo" @click="endMeeting()">
        <img
            :src="require('../../assets/img/action-9.svg')"
            style="width: 20px; height: 20px"
        />
      </div>
      <div class="action-name">Say bye!</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Actions",
  data() {
    return {};
  },
  computed: {
    blurredBackground() {
      return this.$store.state.meeting.blurredBackground
    },
    isRecording() {
      return this.$store.state.meeting.isRecording
    },
    isPublic() {
      return this.$store.state.meeting.meeting.isPublic;
    },
    cameraOrMicBlocked() {
      return this.$store.state.meeting.cameraOrMicBlocked;
    },
    localParticipant() {
      return this.$store.getters.localParticipant;
    },
    waitingParticipants() {
      return [];
    },
    participants() {
      return this.$store.state.meeting.participants;
    },
    messages() {
      return this.$store.state.meeting.messages;
    },
    hasEnded() {
      return this.$store.getters.hasEnded;
    },
    meetingAccessDenied() {
      return this.$store.getters.meetingAccessDenied;
    },
    awaitingAccess() {
      return this.$store.getters.awaitingAccess;
    },
    isMeetingOwner() {
      return this.$store.state.meeting.isOwner;
    },
    notStarted() {
      return this.$store.getters.notStarted;
    },
    isEnteringLobby() {
      return this.$store.getters.isEnteringLobby;
    },
    isInLobby() {
      return this.$store.getters.isInLobby;
    },
    isJoiningMeeting() {
      return this.$store.getters.isJoiningMeeting;
    },
    isJoinedMeeting() {
      return this.$store.getters.isJoinedMeeting;
    },
    hasLeftMeeting() {
      return this.$store.getters.hasLeftMeeting;
    },
    hasMeetingError() {
      return this.$store.getters.hasMeetingError;
    },
  },
  mounted() {
    window.__controls__ = this;
  },

  methods: {
    onBlurClick() {
      if (this.blurredBackground) {
        this.$store.dispatch("stopBlurBackground")
      } else {
        this.$store.dispatch("blurBackground")

      }
    },
    onRecordClick() {
      if (this.isRecording) {
        this.stopRecording()
      } else {
        this.startRecording()
      }
    },
    startRecording() {
      this.$store.dispatch("startRecording");
    },

    stopRecording() {
      this.$store.dispatch("stopRecording");
    },

    startTimer() {
      this.interval = setTimeout(() => {
        this.timer += 0.01;
        this.startTimer();
      }, 1000);
    },

    toggleCaptions() {
      if (this.payedSubscription) {
        this.$store.dispatch("setShowCaptions", !this.showCaptions);
      } else {
        this.$store.commit("showModal", "unlock_features");
      }
    },

    cameraOn() {
      this.$store.dispatch("cameraOn");
    },

    cameraOff() {
      this.$store.dispatch("cameraOff");
    },

    micOn() {
      this.$store.dispatch("micOn");
    },

    micOff() {
      this.$store.dispatch("micOff");
    },

    startScreenShare() {
      this.$store.dispatch("startScreenShare");
    },

    stopScreenShare() {
      this.$store.dispatch("stopScreenShare");
    },
    endMeeting() {
      this.$store.dispatch("endMeeting", true);
    },
    leave() {
      this.$store.dispatch("leaveMeeting");
    },
    showPeopleModal() {
      this.$store.commit("showModal", "people_modal");
    },
    showChatModal() {
      this.$store.commit("showModal", "chat_modal");
    },
  },
};
</script>

<style scoped>
.actions-container {
  display: inline-flex;
  justify-content: center;
  text-align: center;
  width: 100%;
}

.action-logo {
  border-radius: 16px;
  opacity: 1;
  background-color: #000;
  cursor: pointer;
  width: 48px;
  height: 48px;
}

.action-logo:hover {
  background-color: #fc5a12;
}

.p-16 {
  padding: 0 16px;
}

.pl-8 {
  margin-left: 8px !important;
  padding: 0 !important;
}

.pr-8 {
  padding: 0 !important;
  margin-right: 8px !important;
}

.logo-container {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 48px;
}

.action-name {
  padding-top: 16px;
  padding-bottom: 0 !important;
  font-size: 12px;
  line-height: 16px;
  color: #000;
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.active {
  background-color: #fc5a12;
}

.noactive {
  background-color: #000;
}
</style>
